import { Route, Routes, useLocation } from "react-router-dom";
import {
  CONFIGURATION_ROUTER_URL,
  FACULTY_ROUTER_URL,
  FRESHMAN_ROUTER_URL,
  STAFF_ROUTER_URL,
  STUDENT_ROUTER_URL,
} from "../constants/routerUrl";
import ButtonsIndex from "../pages/admin/components/masters/buttons/buttonsIndex";
import WidgetsIndex from "../pages/admin/components/masters/widgets/widgetsIndex";
import AppsIndex from "../pages/admin/components/masters/apps/appsIndex";
import StudentResourceIndex from "../pages/admin/components/masters/studentResources/studentResourceIndex";
import StudentHelpIndex from "../pages/admin/components/masters/studentHelp/studentHelpIndex";
import NotificationsIndex from "../pages/admin/components/masters/notifications/notificationsIndex";
import TechnologyResourcesIndex from "../pages/admin/components/masters/technologyResources/technologyResourcesIndex";
import MediaContentIndex from "../pages/admin/components/masters/mediaContent/mediaContentIndex";
import PriorityButtons from "../pages/admin/components/priorityMasters/priorityButtons";
import PriorityWidgets from "../pages/admin/components/priorityMasters/priorityWidgets";
import PriorityApps from "../pages/admin/components/priorityMasters/priorityApps";
import PriorityNotifications from "../pages/admin/components/priorityMasters/priorityNotifications";
import PriorityTechnologyResources from "../pages/admin/components/priorityMasters/priorityTechnologyResources";
import PriorityMediaContents from "../pages/admin/components/priorityMasters/priorityMediaContents";
import SnapshotsIndex from "../pages/admin/components/masters/snapshots/snapshotsIndex";
import PriorityStudentResources from "../pages/admin/components/priorityMasters/priorityStudentResources";
import PriorityStudentHelps from "../pages/admin/components/priorityMasters/priorityStudentHelps";
import ReportIndex from "../pages/admin/components/masters/report/reportIndex";
import PriorityReports from "../pages/admin/components/priorityMasters/priorityReports";
import PriorityTrainingBlocks from "../pages/admin/components/priorityMasters/priorityTrainingBlocks";
import PriorityDepartmentResources from "../pages/admin/components/priorityMasters/priorityDepartmentResources";
import PriorityTrainingHelps from "../pages/admin/components/priorityMasters/priorityTrainingHelps";
import TrainingIndex from "../pages/admin/components/masters/training/trainingIndex";
import DepartmentResourceIndex from "../pages/admin/components/masters/departmentResources/departmentResourceIndex";
import TrainingHelpIndex from "../pages/admin/components/masters/trainingHelp/trainingHelpIndex";
import EmailConfigurationIndex from "../pages/admin/components/masters/Email/emailConfigurationIndex";
import DescriptionIndex from "../pages/admin/components/masters/descriptions/descriptionIndex";
import MainStepIndex from "../pages/admin/components/freshman/mainStep/mainStepIndex";
import SubStepIndex from "../pages/admin/components/freshman/subStep/subStepIndex";
import FreshmanConfigurationIndex from "../pages/admin/components/freshman/configuration/freshmanConfigurationIndex";
import FreshmanConfigurationView from "../pages/admin/components/freshman/configuration/components/freshmanConfigurationView";

export default function SubRouter() {
  const location = useLocation();
  const userRole = location.state?.userRole;
  return (
    <Routes>
      <Route
        path={CONFIGURATION_ROUTER_URL.BUTTON_INDEX}
        element={<ButtonsIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.WIDGET_INDEX}
        element={<WidgetsIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.APP_INDEX}
        element={<AppsIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.STUDENT_RESOURCE_INDEX}
        element={<StudentResourceIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.STUDENT_HELP_INDEX}
        element={<StudentHelpIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.NOTIFICATION_INDEX}
        element={<NotificationsIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.TECHNOLOGY_RESOURCE_INDEX}
        element={<TechnologyResourcesIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.MEDIA_CONTENT_INDEX}
        element={<MediaContentIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.TRAINING_INDEX}
        element={<TrainingIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.REPORT_INDEX}
        element={<ReportIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.DEPARTMENT_RESOURCE_INDEX}
        element={<DepartmentResourceIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.TRAINING_HELP_INDEX}
        element={<TrainingHelpIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.EMAIL_CONFIGURATION_INDEX}
        element={<EmailConfigurationIndex />}
      ></Route>
      <Route
        path={CONFIGURATION_ROUTER_URL.DESCRIPTION_INDEX}
        element={<DescriptionIndex />}
      ></Route>
      {/* staff */}
      <Route
        path={STAFF_ROUTER_URL.BUTTON_PRIORITY}
        element={<PriorityButtons configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.WIDGET_PRIORITY}
        element={<PriorityWidgets configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.APPS_PRIORITY}
        element={<PriorityApps configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.NOTIFICATION_PRIORITY}
        element={<PriorityNotifications configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.TECHNOLOGY_RESOURCE_PRIORITY}
        element={<PriorityTechnologyResources configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.MEDIA_CONTENT_PRIORITY}
        element={<PriorityMediaContents configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.SNAPSHOT_PRIORITY}
        element={<SnapshotsIndex configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.TRAINING_PRIORITY}
        element={<PriorityTrainingBlocks configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.REPORT_PRIORITY}
        element={<PriorityReports configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.DEPARTMENT_RESOURCE_PRIORITY}
        element={<PriorityDepartmentResources configUserRole={userRole} />}
      ></Route>
      <Route
        path={STAFF_ROUTER_URL.TRAINING_HELP_PRIORITY}
        element={<PriorityTrainingHelps configUserRole={userRole} />}
      ></Route>

      {/* student */}
      <Route
        path={STUDENT_ROUTER_URL.BUTTON_PRIORITY}
        element={<PriorityButtons configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.WIDGET_PRIORITY}
        element={<PriorityWidgets configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.APPS_PRIORITY}
        element={<PriorityApps configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.NOTIFICATION_PRIORITY}
        element={<PriorityNotifications configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.STUDENT_RESOURCE_PRIORITY}
        element={<PriorityStudentResources configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.STUDENT_HELP_PRIORITY}
        element={<PriorityStudentHelps configUserRole={userRole} />}
      ></Route>
      <Route
        path={STUDENT_ROUTER_URL.SNAPSHOT_PRIORITY}
        element={<SnapshotsIndex configUserRole={userRole} />}
      ></Route>

      {/* faculty */}
      <Route
        path={FACULTY_ROUTER_URL.BUTTON_PRIORITY}
        element={<PriorityButtons configUserRole={userRole} />}
      ></Route>
      <Route
        path={FACULTY_ROUTER_URL.WIDGET_PRIORITY}
        element={<PriorityWidgets configUserRole={userRole} />}
      ></Route>
      <Route
        path={FACULTY_ROUTER_URL.APPS_PRIORITY}
        element={<PriorityApps configUserRole={userRole} />}
      ></Route>
      <Route
        path={FACULTY_ROUTER_URL.NOTIFICATION_PRIORITY}
        element={<PriorityNotifications configUserRole={userRole} />}
      ></Route>
      <Route
        path={FACULTY_ROUTER_URL.SNAPSHOT_PRIORITY}
        element={<SnapshotsIndex configUserRole={userRole} />}
      ></Route>
      <Route
        path={FACULTY_ROUTER_URL.REPORT_PRIORITY}
        element={<PriorityReports configUserRole={userRole} />}
      ></Route>
      <Route
        path={FRESHMAN_ROUTER_URL.FRESHMAN_MAINSTEP_INDEX}
        element={<MainStepIndex />}
      ></Route>
      <Route
        path={FRESHMAN_ROUTER_URL.FRESHMAN_SUBSTEP_INDEX}
        element={<SubStepIndex />}
      ></Route>
      <Route
        path={FRESHMAN_ROUTER_URL.FRESHMAN_CONFIGURATION_INDEX}
        element ={<FreshmanConfigurationIndex/>}
        >
      </Route>
    </Routes>
  );
}
